import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext';
import Loading from './Loading';

export default function ProtectedRoute({
  children,
  roles,
  redirectPath = '/',
  loginPath = null
}) {
  const location = useLocation();
  const { loading, isLoggedIn, hasRole, user } = useAuth();

  if (!isLoggedIn && loading) {
    return <Loading />;
  }

  if (!isLoggedIn) {
    const target = loginPath
      ? `${loginPath}?return=${encodeURIComponent(location.pathname)}`
      : '/error?key=unauthorized';
    return (
      <Navigate
        replace
        to={target}
        state={{ from: location.pathname }}
      />
    );
  }

  if (isLoggedIn && roles && !hasRole(...roles)) {
    return <Navigate replace to={redirectPath} />;
  }

  // Tenant access guard: tarkista että käyttäjä kuuluu URL:n organisaatioon
  const tenantMatch = location.pathname.match(/\/tenants\/(\d+)/);
  if (tenantMatch && !user?.isRoot) {
    const routeTenantId = Number(tenantMatch[1]);
    const hasTenantAccess = user?.tenants?.some(t => t.tenantId === routeTenantId);
    if (!hasTenantAccess) {
      return <Navigate replace to='/error?key=forbidden' />;
    }
  }

  return children || <Outlet />;
}
